export default __webpack_public_path__ + "static/media/DangerIcon.9586c9e2.svg";